import { Slot } from '@radix-ui/react-slot'
import { clsx } from 'clsx'
import type { ComponentProps, ReactNode } from 'react'

import styles from './SidebarAddon.module.scss'

interface SidebarAddonProps {
  children: ReactNode
  title: ReactNode
  titleMuted?: boolean
  className?: string
}

export function SidebarAddon(props: SidebarAddonProps) {
  const { children, title, titleMuted, className } = props
  return (
    <div className={clsx(styles.sidebarAddon, className)}>
      <div className={styles.header}>
        <h3
          className={clsx(styles.title, {
            [styles.titleMuted]: titleMuted,
          })}
        >
          {title}
        </h3>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}

interface SidebarAddonTitleLinkProps extends ComponentProps<'a'> {
  asChild?: boolean
}

export function SidebarAddonTitleLink(props: SidebarAddonTitleLinkProps) {
  const { asChild, className, children, ...rest } = props
  const Comp = asChild ? Slot : 'a'

  return (
    <Comp
      {...(rest as Omit<ComponentProps<typeof Comp>, 'ref'>)}
      className={clsx(styles.link, className)}
    >
      {children}
    </Comp>
  )
}
